import React from "react";
import { Row, Col, Button } from "react-bootstrap";
import ExpenseCard from "../../components/ExpenseCard";
import ExpenseChart from "../../components/ExpenseChart";
import ExpenseTable from "../../components/ExpenseTable";

const ExpenseReport = () => {

  const cardData = [
    { title: "Total Expense", amount: "$45,221", percent: 20, isPositive: true },
    { title: "Approved Expense", amount: "$45,221", percent: 17, isPositive: true },
    { title: "Net Pay", amount: "$45,221.45", percent: 10, isPositive: true },
    { title: "Allowances", amount: "$45,221.45", percent: 18, isPositive: false },
  ];

  const chartData = {
    labels: ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],
    datasets: [
      {
        data: [5000,10000,15000,22000,28000,35000,45000,60000,65000,70000,75000,80000],
      }
    ]
  };

  return (
    <div className="container-fluid mt-3 px-4">

      {/* HEADER */}
      <div className="d-flex align-items-center mb-4">
        <h4 className="fw-semibold mb-0">Expense Report</h4>

        <Button className="ms-auto" variant="dark" size="sm">
          Export
        </Button>
      </div>

      <Row className="g-4">

        {/* LEFT SIDE CARDS */}
        <Col md={5}>
          <div className="d-flex flex-wrap">
            {cardData.map((item, index) => (
              <div className="col-6 p-2" key={index}>
                <ExpenseCard {...item} />
              </div>
            ))}
          </div>
        </Col>

        {/* RIGHT SIDE CHART */}
        <Col md={7}>
          <ExpenseChart data={chartData} />
        </Col>

      </Row>

      <ExpenseTable/>

    </div>
  );
};

export default ExpenseReport;